export function renameJobAdderSelects(root) {
    const labels = {
        Category: 'Sector',
        'Work Type': 'Role type',
        Keywords: 'Search',
    };

    root.querySelectorAll('select option').forEach((option) => {
        const text = option.textContent.trim();

        if (labels[text]) {
            option.textContent = labels[text];
        }
    });
}

function bindJobAdderSelectClose(root) {
    if (root.dataset.jobAdderSelectCloseReady) return;

    root.dataset.jobAdderSelectCloseReady = 'true';

    document.addEventListener('click', () => {
        root.querySelectorAll('.jobs-portal-select').forEach((select) => {
            select.classList.remove('is-open');
        });
    });
}

export function setupJobAdderSelects(root) {
    const selects = root.querySelectorAll('.ja-form select');

    selects.forEach((select) => {
        if (select.dataset.jobAdderSelectReady) return;

        select.dataset.jobAdderSelectReady = 'true';

        const source = select.parentNode;
        const options = [...select.options];

        if (!source || !options.length) return;

        const customSelect = document.createElement('div');
        customSelect.className = 'jobs-portal-select';

        const trigger = document.createElement('div');
        trigger.className = 'jobs-portal-select__trigger';
        trigger.textContent = select.options[select.selectedIndex].textContent;
        trigger.setAttribute('tabindex', '1');

        const dropdown = document.createElement('div');
        dropdown.className = 'jobs-portal-select__dropdown';

        const list = document.createElement('div');
        list.className = 'jobs-portal-select__list';

        options.forEach((option) => {
            const optionEl = document.createElement('div');

            optionEl.className = 'jobs-portal-select__option';
            optionEl.dataset.value = option.value;
            optionEl.textContent = option.textContent;
            optionEl.setAttribute('tabindex', '1');

            if (option.value === select.value) {
                optionEl.classList.add('active');
            }

            if (option.value === '0') {
                optionEl.classList.add('default');
            }

            optionEl.addEventListener('click', (event) => {
                event.stopPropagation();

                select.value = option.value;
                trigger.textContent = option.textContent;

                list.querySelectorAll('.jobs-portal-select__option').forEach((el) => {
                    el.classList.remove('active');
                });

                optionEl.classList.add('active');
                customSelect.classList.remove('is-open');

                select.dispatchEvent(new Event('change', { bubbles: true }));
            });

            list.append(optionEl);
        });

        trigger.addEventListener('click', (event) => {
            event.stopPropagation();

            root.querySelectorAll('.jobs-portal-select').forEach((el) => {
                if (el !== customSelect) {
                    el.classList.remove('is-open');
                }
            });

            customSelect.classList.toggle('is-open');
        });

        dropdown.append(list);
        customSelect.append(trigger, dropdown);
        source.append(customSelect);
    });

    bindJobAdderSelectClose(root);
}

export function scrollToJobAdderWidget(root) {
    const offset = 40;
    const top = root.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
        top,
        behavior: 'smooth',
    });
}


export function handleJobAdderScroll(root) {
    let currentView = null;

    if (root.querySelector('.ja-job-apply')) {
        currentView = 'apply';
    } else if (root.querySelector('.ja-job-details')) {
        currentView = 'details';
    } else if (root.querySelector('.ja-job-list')) {
        currentView = 'list';
    } else if (root.querySelector('.ja-application-submitted')) {
        currentView = 'submitted';
    }

    if (!currentView) return;

    const previousView = root.dataset.jobAdderCurrentView;

    if (previousView === currentView) return;

    root.dataset.jobAdderCurrentView = currentView;

    if (!previousView) return;

    scrollToJobAdderWidget(root);
}